import { useEffect } from 'react'
import { Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import ProtectedRoute from './components/ProtectedRoute'
import Layout from './components/Layout'
import Login from './pages/Login'
import Register from './pages/Register'
import Dashboard from './pages/Dashboard'
import DataSection from './pages/DataSection'
import AssetDataDetail from './pages/AssetDataDetail'
import AssetProducts from './pages/AssetProducts'
import AssetProductDetail from './pages/AssetProductDetail'
import Analytics from './pages/Analytics'
import SettingsLayout from './pages/Settings/SettingsLayout'
import SettingsProfile from './pages/Settings/Profile'
import SettingsSecurity from './pages/Settings/Security'
import RoleManagement from './pages/RoleManagement'
import AccountManagement from './pages/AccountManagement'
import ExportLogManagement from './pages/ExportLogManagement'
import ImportLogManagement from './pages/ImportLogManagement'
import NotFound from './pages/NotFound'
import { useTheme } from './hooks/useTheme'

function App() {
  useTheme()
  const location = useLocation()
  const navigate = useNavigate()
  // 避免 /assets/ 等带尾斜杠的路径：刷新时服务器可能当目录请求返回 403，统一重定向到无尾斜杠
  useEffect(() => {
    const pathname = location.pathname
    if (pathname !== '/' && pathname.endsWith('/')) {
      navigate(pathname.slice(0, -1), { replace: true })
    }
  }, [location.pathname, navigate])

  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="data" element={<DataSection />}>
            <Route index element={null} />
            <Route path=":id" element={<AssetDataDetail />} />
          </Route>
          <Route path="assets" element={<AssetProducts />} />
          <Route path="assets/:id" element={<AssetProductDetail />} />
          <Route path="analytics" element={<Analytics />} />
          <Route path="settings" element={<SettingsLayout />}>
            <Route index element={<Navigate to="profile" replace />} />
            <Route path="profile" element={<SettingsProfile />} />
            <Route path="security" element={<SettingsSecurity />} />
          </Route>
          <Route path="roles" element={<RoleManagement />} />
          <Route path="accounts" element={<AccountManagement />} />
          <Route path="import-logs" element={<ImportLogManagement />} />
          <Route path="export-logs" element={<ExportLogManagement />} />
          <Route path="*" element={<NotFound />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  )
}

export default App
